/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import LookupActions from '../lookup-actions';

const CONSTANTS = {
    GET: {
        ERROR: 'titleCatalog_actions.get.error',
        START: 'titleCatalog_actions.get.start',
        SUCCESS: 'titleCatalog_actions.get.success'
    },
    MESSAGES: {
        CREATE_ERROR: 'lookups.titleCatalog.create.error',
        CREATE_OK: 'lookups.titleCatalog.create.ok',
        REMOVE_ERROR: 'lookups.titleCatalog.remove.error',
        REMOVE_OK: 'lookups.titleCatalog.remove.ok',
        SAVE_ERROR: 'lookups.titleCatalog.save.error',
        SAVE_OK: 'lookups.titleCatalog.save.ok',
    },
    REMOVE_OK: 'titleCatalog_actions.remove',
    SAVE_OK: 'titleCatalog_actions.save'
};

class TitleCatalogActions extends LookupActions {

    constructor(path, CONSTS) {
        super(path, CONSTS);
    }

}

// Libraries are just title groups of type TitleCatalog.
let actions = new TitleCatalogActions('security/group?category-id=1&title-catalog-type=1', CONSTANTS);

export {
    actions as TitleCatalogActions,
    CONSTANTS as TitleCatalogConstants
};
